import { useState } from "react";
import { Accordion, Button, Col, Form, Row } from "react-bootstrap";
import useCustomer from "../../context/CustomerContext";
import { useDeleteRateCardMutation, useGetDefaultPricingRateCardListQuery } from "../../features/cwtRateCard/cwtRateCardSlice";
import { useCustomData } from "../Sidebar/Permission";
import Spinner from "../Spinner";
import AccessorialSurcharge from "./Accessorial/AccessorialSurcharge";
import EditAccessorialSurcharge from "./Accessorial/EditAccessorial";
import ContractData from "./Contract/ContractData";
import EditContractdata from "./Contract/EditContractData";
import SaveContractdata from "./Contract/SaveContractData";
import CwtRatecard from "./CwtRateCard/CwtRatecard";
import EditCwtRatecard from "./CwtRateCard/EditCwtRatecard";
import CityDistance from "./FuelSurcharge/CityDistance";
import DistanceFuel from "./FuelSurcharge/DistanceFuel";
import EditCityDistance from "./FuelSurcharge/EditCitydistance";
import EditDistanceFuel from "./FuelSurcharge/EditDistanceFuel";
import EditRemoteLogin from "./FuelSurcharge/EditRemoteLogin";
import FuelCostTable from "./FuelSurcharge/FuelCostTable";
import RemoteLogin from "./FuelSurcharge/RemoteLogin";
import EditServiceSurcharge from "./Service/EditServiceSurcharge";
import ServiceSurchargeSection from "./Service/ServiceSurchargeSection";
import Specialaddress from "./Specialaddress";
import EditVehicleSurcharge from "./Vehicle/EditVehicleSurcharge";
import VehicleSurcharge from "./Vehicle/VehicleSurcharge";
import errorHandler from "../hooks/ErrorHanlder";
import { toast } from "react-toastify";
import Dialog from "../designSystem/Dialog";

const Contract = ({ hideSpecialAddress = false, component = "CUSTOMER" }) => {
  const [permission] = useCustomData()
  const [deleteRateCard] = useDeleteRateCardMutation();
  const { errors, selected, contractInfo, validateContractPricing, multiplier, setMultiplier, getDefaultCard, loading, handleAccount, singleAccount, companyProfile } = useCustomer();
  const rateCard = contractInfo ? contractInfo.length > 0 : false;
  const [isEditMode, setShowEditRate] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(0);
  const { data: rateCards } = useGetDefaultPricingRateCardListQuery();
  const combinations = { 1: 'Zone-CWT', 2: 'Region-CWT', 3: 'Zone-Pallet', 4: 'Region-Pallet' }
  const account = singleAccount && singleAccount[0];

  const showedithandler = () => {
    setShowEditRate(!isEditMode);
  }

  const deleteHandler = async () => {
    const rateCardId = companyProfile?.rateCardDetails?.mLContractInfos[0]?.rateCardId ? companyProfile?.rateCardDetails?.mLContractInfos[0]?.rateCardId : contractInfo[0]?.rateCardId

    try {
      await deleteRateCard(rateCardId).unwrap();
      handleAccount(account?.account_No);
      toast.success("Rate Card deleted Successfully", { position: "top-center" });
      setIsOpen(false);
    } catch (error) {
      errorHandler(error)
    }

  }
  return (
    <>
      {(selected && !rateCard) && component === "CUSTOMER" &&
        <Row className="justify-content-end mb-3">
          <Col xs="auto">
            {loading ? <div style={{ display: "grid", placeItems: "center", width: "100%" }}> <Spinner /></div> :
              <Button onClick={() => validateContractPricing(selectedCard, { EntityType: "CUSTOMER" })}  >
                Add Rate Card
              </Button>}
          </Col>
        </Row>
      }
      <Dialog title="Delete Rate Card" show={isOpen} onClose={() => setIsOpen(false)} description="Are you sure you want to Delete Rate Card" onSubmit={deleteHandler} />
      {contractInfo[0]?.rateCardId != null ? <div className="d-flex justify-content-end mb-3">
        <Button variant="outline-danger" onClick={() => setIsOpen(true)}>Delete Rate Card</Button>
      </div> : null}
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>Rate Card</Accordion.Header>
          <Accordion.Body>
            <>
              {/* Contract Info */}
              {component === "COMPANY_PROFILE" ? null : <Row className="mb-4 justify-content-between">
                {(selected && !rateCard) &&
                  <>
                    <Col sm={3}>
                      <Form.Select aria-label="Default select example"
                        onChange={(e) => {
                          if (e.target.value !== '0') {
                            getDefaultCard(e.target.value)
                          }
                          setSelectedCard(e.target.value);
                        }}
                      >
                        <option value='0'>Choose a Default Rate Card</option>
                        {rateCards?.data && rateCards.data.map((rateCard) => (
                          <option value={rateCard.rateCardId}>{combinations[rateCard.rateCardId]}</option>
                        ))
                        }
                      </Form.Select>
                    </Col>

                    <Col sm={2}>
                      <div className="form-floating">
                        <Form.Control type="number" placeholder="Multiplier" name="Multiplier" onChange={(e) => { setMultiplier(e.target.value); }}
                          className={`input ${errors.Multiplier && 'is-danger'}`} value={multiplier} required />
                        <label htmlFor="multiplier">Multiplier (%)</label>
                      </div>
                    </Col> </>}
              </Row>}
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Contract Info Section</Accordion.Header>
                  <Accordion.Body>
                    {!isEditMode ?
                      <>{selected && rateCard ?
                        <> {permission?.find(event => event.moduleId === 40) ? <EditContractdata showedithandler={showedithandler} /> : <p className="no-access-msg">No Access Permission</p>}</> :
                        <> {permission?.find(event => event.moduleId === 40) ? <ContractData /> : <p className="no-access-msg">No Access Permission</p>}</>
                      }</>
                      : <SaveContractdata showedithandler={showedithandler} />}
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Vehicle Surcharge Section</Accordion.Header>
                  <Accordion.Body>
                    {/* Vehicle surcharge section*/}
                    {selected && rateCard ?
                      <> {permission?.find(event => event.moduleId === 41) ? <EditVehicleSurcharge /> : <p className="no-access-msg">No Access Permission</p>}</> :
                      <> {permission?.find(event => event.moduleId === 41) ? <VehicleSurcharge /> : <p className="no-access-msg">No Access Permission</p>}</>
                    }
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>Service Surcharge Section</Accordion.Header>
                  <Accordion.Body>
                    {/* Service surcharge section*/}
                    {selected && rateCard ?
                      <> {permission?.find(event => event.moduleId === 42) ? <EditServiceSurcharge /> : <p className="no-access-msg">No Access Permission</p>}</> :
                      <> {permission?.find(event => event.moduleId === 42) ? <ServiceSurchargeSection /> : <p className="no-access-msg">No Access Permission</p>}</>
                    }
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>Accessorial Charge Section</Accordion.Header>
                  <Accordion.Body>
                    {/* Accessorial Charge section*/}
                    {selected && rateCard ?
                      <> {permission?.find(event => event.moduleId === 43) ? <EditAccessorialSurcharge /> : <p className="no-access-msg">No Access Permission</p>}</> :
                      <> {permission?.find(event => event.moduleId === 43) ? <AccessorialSurcharge /> : <p className="no-access-msg">No Access Permission</p>}</>}
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>CWT Rate Card Section</Accordion.Header>
                  <Accordion.Body>
                    {/* CWT Rate Card Section*/}
                    {selected && rateCard ?
                      <> {permission?.find(event => event.moduleId === 44) ? <EditCwtRatecard /> : <p className="no-access-msg">No Access Permission</p>}</> :
                      <> {permission?.find(event => event.moduleId === 44) ? <CwtRatecard /> : <p className="no-access-msg">No Access Permission</p>}</>
                    }
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>Fuel Surcharge Section</Accordion.Header>
                  <Accordion.Body>
                    {((!contractInfo.FuelSurchargeMethod || contractInfo.FuelSurchargeMethod === 'Select') && (Array.isArray(contractInfo)) && contractInfo.length === 0) &&
                      <Row className="mb-4 mt-4">
                        <p>Please choose a Fuel Surcharge Method in Contract Info Section </p>
                      </Row>
                    }
                    {(contractInfo.FuelSurchargeMethod === 2 || contractInfo.FuelSurchargeMethod === '2' || (selected && contractInfo.length > 0 && contractInfo[0].fuelSurchargeMethod === 2)) && <>
                      {selected && rateCard ?
                        <> {permission?.find(event => event.moduleId === 45) ? <EditCityDistance /> : <p className="no-access-msg">No Access Permission</p>}</> :
                        <> {permission?.find(event => event.moduleId === 45) ? <CityDistance /> : <p className="no-access-msg">No Access Permission</p>}</>
                      }
                      {selected && rateCard ?
                        <> {permission?.find(event => event.moduleId === 45) ? <EditDistanceFuel /> : <p className="no-access-msg">No Access Permission</p>}</> :
                        <> {permission?.find(event => event.moduleId === 45) ? <DistanceFuel /> : <p className="no-access-msg">No Access Permission</p>}</>
                      }
                      {selected && <FuelCostTable />} </>
                    }
                    {(contractInfo.FuelSurchargeMethod === 1 || contractInfo.FuelSurchargeMethod === '1' || (selected && contractInfo.length > 0 && contractInfo[0].fuelSurchargeMethod === 1)) && <>
                      {selected && rateCard ?
                        <> {permission?.find(event => event.moduleId === 45) ? <EditRemoteLogin /> : <p className="no-access-msg">No Access Permission</p>}</> :
                        <> {permission?.find(event => event.moduleId === 45) ? <RemoteLogin /> : <p className="no-access-msg">No Access Permission</p>}</>
                      } </>
                    }
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </>
          </Accordion.Body>
        </Accordion.Item>
        {hideSpecialAddress ? null : <Accordion.Item eventKey="1">
          <Accordion.Header>Special Address</Accordion.Header>
          <Accordion.Body>
            <Specialaddress />
          </Accordion.Body>
        </Accordion.Item>}
      </Accordion>
    </>

  )
}
export default Contract;
